function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { validateError } from '@/services/services';
import tasks from '@/js/tasks';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
// declare service gtw
var appApisGTW = null;
if (!configuration['audiences']) {
  appApisGTW = axios.create({
    // baseURL: process.env.VUE_APP_CR_AUDIENCIAS
    baseURL: 'http://localhost:8000'
    // baseURL: "https://crun-itc-dp-audience-intercorp-qmuzefzuga-uc.a.run.app"
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_CR_AUDIENCIAS
    // baseURL: "http://localhost:8000"
    // baseURL: "https://crun-itc-dp-audience-intercorp-qmuzefzuga-uc.a.run.app"
  });
}
var beforeMiddleware = function beforeMiddleware(config) {
  // tasks.getUserInfo()
  config.headers['Authorization'] = 'Bearer ' + window.userInfo.accessToken;
  return config;
};
var key = 'key=' + process.env.VUE_APP_API_KEY;
// appApisGTW.before(beforeMiddleware)
setupInterceptors(appApisGTW);
var loginObj = function loginObj() {
  return {
    email: window.userInfo.email,
    tokenId: window.userInfo.accessToken,
    localId: window.userInfo.localId
  };
};
export default {
  insertSegment: function insertSegment(payload) {
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/segment/insert', payload, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  bulkUpdateAudiences: function bulkUpdateAudiences(payload) {
    tasks.lockScreen.lock();
    return appApisGTW.put('/audience-management/audiences/bulkUpdateAudiences', payload, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  replaceAdobeTest: function replaceAdobeTest(payload) {
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/audiences/published/replace-adobe-test', payload, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  getBaseUrl: function getBaseUrl() {
    return process.env.VUE_APP_CR_AUDIENCIAS;
  },
  getPlatformList: function getPlatformList() {
    return appApisGTW.get('/audience-management/audiences/platform/list', {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      return res.data;
    });
  },
  getAudiencias: function getAudiencias(companyCode) {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.get('/audience-management/audiences/list?company_code=' + companyCode + '&' + key, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }); /* .catch(err => {
              const message = '(getAreas) listar areas en user profile'
              // const response = validateError(err, message)
              //return validateError(err, message, () => { this.getSegmentos(data) })
          })*/
  },
  getEstateAudiences: function getEstateAudiences(data) {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);

    // tasks.lockScreen.lock()
    return appApisGTW.get('/audience-management/audiences/states/list?' + key, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      // tasks.lockScreen.unlock()
      return res.data;
    }); /* .catch(err => {
              const message = '(getAreas) listar areas en user profile'
              // const response = validateError(err, message)
              //return validateError(err, message, () => { this.getSegmentos(data) })
          })*/
  },
  createAudience: function createAudience(data) {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({}, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/audiences/create?' + key, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }); /* .catch(err => {
              const message = '(getAreas) listar areas en user profile'
              // const response = validateError(err, message)
              return validateError(err, message, () => { this.createAudience(data) })
          })*/
  },
  createAutomationSalesforce: function createAutomationSalesforce(data) {
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/audiences/create-automation-salesforce', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  getAudienceById: function getAudienceById(data) {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.get('/audience-management/audiences/' + data.custom_audience_id + '/retrieve?' + key, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }); /* .catch(err => {
              const message = '(getAreas) listar areas en user profile'
              // const response = validateError(err, message)
              //return validateError(err, message, () => { this.getSegmentos(data) })
          })*/
  },
  updateAudience: function updateAudience(data) {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.get('/audience-management/crossing-segment/preview?' + key, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }); /* .catch(err => {
              const message = '(getAreas) listar areas en user profile'
              // const response = validateError(err, message)
              //return validateError(err, message, () => { this.getSegmentos(data) })
          })*/
  },
  activateAudiencia: function activateAudiencia(custom_audience_id) {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.put('/audience-management/audiences/' + custom_audience_id + '/activate', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }); /* .catch(err => {
              const message = '(getAreas) listar areas en user profile'
              // const response = validateError(err, message)
              //return validateError(err, message, () => { this.getSegmentos(data) })
          })*/
  },
  deactivateAudiencia: function deactivateAudiencia(custom_audience_id) {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.put('/audience-management/audiences/' + custom_audience_id + '/deactivate', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }); /* .catch(err => {
              const message = '(getAreas) listar areas en user profile'
              // const response = validateError(err, message)
              //return validateError(err, message, () => { this.getSegmentos(data) })
          })*/
  },
  eliminarAudiencia: function eliminarAudiencia(custom_audience_id) {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.put('/audience-management/audiences/' + custom_audience_id + '/delete', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }); /* .catch(err => {
              const message = '(getAreas) listar areas en user profile'
              // const response = validateError(err, message)
              //return validateError(err, message, () => { this.getSegmentos(data) })
          })*/
  },
  actualizarAudiencia: function actualizarAudiencia(data, custom_audience_id) {
    var body = _objectSpread({}, data);
    tasks.lockScreen.lock();
    return appApisGTW.put('/audience-management/audiences/' + custom_audience_id + '/edit', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  getCuentaPublicitaria: function getCuentaPublicitaria(business_code) {
    console.log(business_code);
    var body = {};
    tasks.lockScreen.lock();
    return appApisGTW.get('/audience-management/ads-accounts/list' + (business_code ? '?company_code=' + business_code : ''), {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  getListAudiencesByRestrictionDataApproved: function getListAudiencesByRestrictionDataApproved() {
    var body = {};
    tasks.lockScreen.lock();
    return appApisGTW.get('/audience-management/audiences/list-restriction-data-approved', {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  generateImage: function generateImage(data) {
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-images/vertex/generate', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  getListImages: function getListImages(id, is_audience) {
    tasks.lockScreen.lock();
    return appApisGTW.get('/audience-images/audience/' + id + '/' + is_audience + '/list', {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  changeState: function changeState(id, state, is_audience) {
    tasks.lockScreen.lock();
    return appApisGTW.put('/audience-images/' + id + '/' + is_audience + '/update/' + state + '/state', {}, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  deleteImage: function deleteImage(id, is_audience) {
    tasks.lockScreen.lock();
    return appApisGTW.delete('/audience-images/' + id + '/' + is_audience + '/delete', {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  downloadImage: function downloadImage(id, image_path, loading, is_audience) {
    var body = {
      id_audiencia: id,
      filename_storage: image_path
    };
    if (loading) {
      tasks.lockScreen.lock();
    }
    return appApisGTW.get('/audience-images/image-view/' + id + is_audience + '/' + image_path, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  resendAudience: function resendAudience(custom_audience_id) {
    var body = {
      custom_audience_id: custom_audience_id
    };
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/audiences/resend', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  frequencyUpdate: function frequencyUpdate(custom_audience_id) {
    var body = {
      custom_audience_id: custom_audience_id
    };
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/audiences/frequency-update', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  billing_process_dates: function billing_process_dates(ads_audience_id) {
    var body = {
      ads_audience_id: ads_audience_id
    };
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/audiences/billing/process-dates', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  billing_list: function billing_list(ads_audience_id, process_date) {
    var body = {
      ads_audience_id: ads_audience_id,
      process_date: process_date
    };
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/audiences/billing/list', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  startBilling: function startBilling(custom_audience_id) {
    var body = {
      custom_audience_id: custom_audience_id
    };
    tasks.lockScreen.lock();
    return appApisGTW.post('/audience-management/audiences/start-billing', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  }
};